<button mat-mini-fab color="primary" type="button" aria-label="Ir hacia arriba" [matTooltip]="'Ir hacia arriba'" matTooltipPosition="left" class="back-to-top-button"
        [@appearInOut]="animationState" (click)="scrollTop($event)">
  <mat-icon color="accent" style="color: black">keyboard_arrow_up</mat-icon>
</button>
